import { render, staticRenderFns } from "./MultiselectQuestion.vue?vue&type=template&id=af98c0dc&scoped=true"
import script from "./MultiselectQuestion.vue?vue&type=script&lang=js"
export * from "./MultiselectQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultiselectQuestion.vue?vue&type=style&index=0&id=af98c0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af98c0dc",
  null
  
)

export default component.exports